import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { AI_SPEND_CATEGORY_QUERY } from "@/apis/taxonomy/queries";
import type { RootQueryType } from "@/generated/taxonomy";
import { TAXONOMY_CLIENT } from "@/utils/consts";
import type { SpendCategoryOption } from "../itSpend/options";

export function useAiSpendCategories(): SpendCategoryOption[] {
  const { data } = useQuery<Pick<RootQueryType, "spendAiCategory">>(
    AI_SPEND_CATEGORY_QUERY,
    { context: { clientName: TAXONOMY_CLIENT } }
  );

  return useMemo(
    () =>
      (data?.spendAiCategory?.data ?? []).flatMap((c) =>
        c?.id && c.name
          ? [
              {
                id: c.id,
                name: c.name,
                parentId: c.parentId ?? "",
                nameTree: (c.nameTree ?? []).filter((n): n is string => !!n),
              },
            ]
          : []
      ),
    [data]
  );
}
